module.exports = __webpack_public_path__ + "static/media/brewfactorLogo.18850834.png";